<div class="detail-input">
  <label class="input-label inline-editable-label" [for]="id" *ngIf="label">{{
    label
  }}</label>
  <mat-form-field appearance="fill" [class.editing]="isEditing === true">
    <input
      #inputElement
      matInput
      [id]="id"
      [name]="id"
      type="text"
      [placeholder]="placeholder"
      [formControl]="inputControl"
      (mouseenter)="onMouseEnter()"
      (mouseleave)="onMouseLeave()"
      (focus)="onFocus()"
      (blur)="onBlur($event)"
      (keyup)="onKeyUp($event)"
      [disabled]="isDisabled"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="onSelectSearchValue($event)"
    >
      <mat-option
        *ngFor="let option of filteredOptions | async"
        (mousedown)="$event.preventDefault()"
        [value]="option.value"
      >
        {{ option.text }}
      </mat-option>
    </mat-autocomplete>
    <mat-icon matSuffix aria-hidden="true">{{ icon | async }}</mat-icon>
    <mat-error *ngIf="inputControl.invalid">
      {{ errorMessage }}
    </mat-error>
  </mat-form-field>
</div>
